<template>
    <section class="change-chart-container">
        <div
        v-for="item in chartChangeInfo" :key="item.key"
        class="chart"
        :class="{'active': item.open}"
        @click="chartChange(item.key)"
    >
        <img v-if="item.open" :src="item.active_ico" alt="">
        <img v-else :src="item.ico"  >
    </div>
    </section>
<div>
</div>
<article class="dominance-parent-container" >
    <div v-if="isGauge" class="dominance-container">
        <DominanceGuageChart/>
    </div>
    <div v-else>
        <DominanceLineChart />
    </div>
</article>

</template>

<script setup>
import DominanceGuageChart from '@/components/chart/dominance/DominanceGuageChart.vue';
import DominanceLineChart from '@/components/chart/dominance/DominanceLineChart.vue';
import gauge_ico         from '@/assets/images/icons/chart/dark/dominance_gauge_ico.svg';
import gauge_active_ico  from '@/assets/images/icons/chart/dark/dominance_gauge_active_ico.svg';
import line_ico          from '@/assets/images/icons/chart/dark/dominance_line_ico.svg';
import line_active_ico   from '@/assets/images/icons/chart/dark/dominance_line_active_ico.svg';
import {ref} from 'vue';
// import DominanceChart from '@/components/DominanceChart.vue';
// import DominanceSignalChart from '@/components/dominance/DominanceSignalChart.vue';
let isGauge = ref(true);
const chartChangeInfo = ref([
    {
        key             : 'gauge',
        open            : true,
        ico             : gauge_ico,
        active_ico      : gauge_active_ico,
    },
    {
        key             : 'line',
        open            : false,
        ico             : line_ico,
        active_ico      : line_active_ico,
    },
]);
const chartChange = (key) => {
    const isOpen = chartChangeInfo.value.find(ob=> ob.key === key).open;
    if(isOpen) return;
    chartChangeInfo.value.forEach(item => {
        item.open = false;
    });

    if(key == 'line') {
        isGauge.value = false;
    } else {
        isGauge.value = true ;
    }
    chartChangeInfo.value.find(ob=> ob.key === key).open =  isOpen ? false : true;
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/charts/dominance.scss";
</style>